import React, { ComponentProps } from 'react';

import { Box } from '@adsk/alloy-react-box';

import i18n from '../../helpers/i18n';

export const EmptyState = (props: ComponentProps<typeof Box>) => (
  <Box padding="16px" textAlign="center" {...props}>
    {i18n.t('NO_RESULTS_FOUND')}
  </Box>
);
